import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadMomentOperation = 'ReadMomentV3'

export type ReadMomentV3ResponseData = OpalApiResponseDocument<
  ReadMomentOperation,
  200
>

export type ReadMomentV3RequestParams =
  OpalApiRequestParams<ReadMomentOperation>

export async function readMoment(
  params: ReadMomentV3RequestParams
): Promise<ReadMomentV3ResponseData> {
  const url = new URL(
    `/moments/v3/${params.path.moment_id}`,
    window.location.origin
  )

  url.search = queryString(params?.query)

  return HttpClient()
    .get<ReadMomentV3ResponseData>(url.toString())
    .then((res) => res.data)
}

type ReadMomentsV3RequestParams = OpalApiRequestParams<'ReadMomentsV3'>
type ReadMomentsV3ResponseData = OpalApiResponseDocument<'ReadMomentsV3', 200>

export async function readCollection(
  params: ReadMomentsV3RequestParams
): Promise<ReadMomentsV3ResponseData> {
  const url = new URL(`/moments/v3`, window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get<ReadMomentsV3ResponseData>(url.toString())
    .then((res) => res.data)
}
